module.exports = __webpack_public_path__ + "img/lbt_1.0d3055b6.jpg";